import React from 'react';
import './RequestComment.scss';
import MarkdownContent from 'components/Markdown';
import Divider from 'components/Common/Divider';

export interface RequestCommentProps {
    author: string;
    timestamp: string;
    content: string;
}

const RequestComment = ({author, timestamp, content} : RequestCommentProps) => {

    const date = new Date(timestamp)
    const timeStampInDate = date.toLocaleString(["en-US"], {month: "long", day: "numeric", year: "numeric"})

    return (
        <div className="comment-container">
            <div className="comment-header">
                <h3 className='comment-header__author'>{author}</h3>
                <p className='comment-header__timestamp'>{timeStampInDate}</p>
            </div>
            <MarkdownContent content={content.replace(/<img .*?>/g,"")} className='comment-body' />
            <Divider />
        </div>
    )
}

export default RequestComment;
